<template>
  <div class="product">
    <template v-if="isRateOffered(rate.key)">
      <div class="relative">
        <DrIcon
          v-if="isRateActive(rate.key)"
          svg="checkmark-solid"
          width="24"
          height="24"
          class="text-green-500 float-left mr-1 mt-0"
        />
        <h3 class="mb-1 text-base font-bold">{{ title }}</h3>
        <DrIcon
          v-if="showRate"
          svg="info"
          width="24"
          height="24"
          class="absolute top-0 text-grey-200 card-icon cursor-pointer"
          @click.native="getSlides(rate.key)"
        />
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="product-description" v-html="content.card_content" />
    </template>
    <template v-else>
      <h3 class="mb-1 text-base font-bold">{{ title }}</h3>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="product-description" v-html="content.card_content" />
    </template>
  </div>
</template>

<script>
import getSlidesMixin from '@/mixins/getSlides'
import rateMixin from '@/mixins/rate'

export default {
  mixins: [getSlidesMixin, rateMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content () {
      return this.getRateContent(this.rate.key)
    },
    // do not show info icon for EmploymentPracticesLiability and Crime if DirectorsAndOfficers isn't configured
    showRate () {
      if (
        this.rate.key === 'ManagementLiability\\EmploymentPracticesLiability' ||
        this.rate.key === 'ManagementLiability\\Crime'
      ) {
        return this.isRateOffered('ManagementLiability\\DirectorsAndOfficers')
      }

      return true
    },
    slides: {
      get () {
        return this.$store.getters.getSlides
      },
      set (value) {
        this.$store.commit(`updateSlides`, value)
      },
    },
    backgroundImage: {
      get () {
        return this.$store.getters.getSlidesBackground
      },
      set (value) {
        this.$store.commit(`updateSlidesBackground`, value)
      },
    },
  },
  methods: {
    emitEvent () {
      this.$emit('showSlides')
    },
  },
}
</script>

<style scoped>
/* v-deep is used to reach child element not in component scope (e.g. in v-html) */
.product::v-deep p {
  @apply text-sm mb-3;
}

.card-icon {
  right: -4px;
}
</style>
